export const permissionCheck = (list, item) => list.includes(item)